import { buildApiUrl } from "../utils/apiConfig";
import type { HelpArticleDetail, HelpArticleList, HelpArticleListQuery } from "../types/help";
import { apiClient } from "../utils/apiClient";

const jsonGetOptions: RequestInit = {
    method: "GET",
    headers: { Accept: "application/json" },
    credentials: "include",
};

export const HELP_ARTICLE_PAGE_SIZE = 10;
export const HELP_ARTICLE_SEARCH_MAX_LENGTH = 120;
const MAX_PAGE_SIZE = 100;

function buildHelpArticleListUrl(query: HelpArticleListQuery = {}): string {
    const params = new URLSearchParams();
    const page = query.page != null && query.page > 0 ? query.page : 0;
    const requestedSize = query.size ?? HELP_ARTICLE_PAGE_SIZE;
    const size = requestedSize < 1 ? HELP_ARTICLE_PAGE_SIZE : Math.min(requestedSize, MAX_PAGE_SIZE);
    params.set("page", String(page));
    params.set("size", String(size));
    const search = (query.search ?? "").trim().slice(0, HELP_ARTICLE_SEARCH_MAX_LENGTH);
    if (search) {
        params.set("search", search);
    }
    return buildApiUrl(`api/help/articles?${params.toString()}`);
}

export async function fetchHelpArticles(query: HelpArticleListQuery = {}): Promise<HelpArticleList> {
    const response = await apiClient(buildHelpArticleListUrl(query), jsonGetOptions);

    if (!response.ok) {
        throw new Error("LOAD_FAILED");
    }

    return response.json();
}

export async function fetchHelpArticle(slug: string): Promise<HelpArticleDetail | null> {
    const response = await apiClient(
        buildApiUrl(`api/help/articles/${encodeURIComponent(slug)}`),
        jsonGetOptions,
    );

    if (response.status === 404) {
        return null;
    }

    if (!response.ok) {
        throw new Error("LOAD_FAILED");
    }

    return response.json();
}
